import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Translate } from "react-redux-i18n";
import { FaCheckCircle } from "react-icons/fa";
import "./styles/RegisterForm.css";

const TIPS = [
  "register_tip1",
  "register_tip2",
  "register_tip3",
  "register_tip4",
  "register_tip5",
  "register_tip6",
];

class RegisterTips extends Component {
  render() {
    return (
      <aside className="register-tips">
        <div className="register-tips__content">
          <p className="register-tips__eyebrow">Godiway</p>
          <h2 className="register-tips__title">
            <Translate value="godiway_wellcome" />
          </h2>
          <p className="register-tips__lead">
            <Translate value="joinwinall1" /> <Translate value="joinwinall2" />
          </p>

          <ul className="register-tips__list">
            {TIPS.map((tipKey) => (
              <li key={tipKey} className="register-tips__item">
                <FaCheckCircle className="register-tips__icon" aria-hidden="true" />
                <span>
                  <Translate value={tipKey} />
                </span>
              </li>
            ))}
          </ul>

          <p className="register-tips__pricing">
            <Translate value="register_tip7" />{" "}
            <Link to="/pricing">
              <Translate value="register_tip8" />
            </Link>
          </p>
        </div>
      </aside>
    );
  }
}

export default RegisterTips;
